<template>
  <div class="lynda-report-attachment">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M14 3H6v18h12V7l-4-4Z" /><path d="M14 3v5h4M9 12h6M9 16h6" /></svg>
    <div>
      <strong>{{ report.title }}</strong>
      <p>PDF · MyGraduationClip</p>
      <button class="mgc-button mgc-button--secondary" :disabled="loading" @click="save">{{ loading ? 'Preparing download…' : 'Download PDF' }}</button>
      <p class="lynda-report-note">Download before this chat ends. Review before sharing.</p>
      <p v-if="error" role="alert">{{ error }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LyndaReportAttachment',
  props: { report: { type: Object, required: true }, download: { type: Function, required: true }, jobId: { type: String, required: true } },
  data() { return { loading: false, error: '' } },
  methods: {
    async save() {
      this.loading = true
      this.error = ''
      try {
        const url = await this.download(this.jobId, this.report.id)
        if (new URL(url).protocol !== 'https:') throw new Error('Invalid download')
        const link = document.createElement('a')
        link.href = url
        link.download = 'ask-lynda-report.pdf'
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (err) {
        this.error = [403, 404, 410].includes(err.response?.status)
          ? 'This report is no longer available. Ask Lynda to create a new report in an active chat.'
          : 'The download could not start. Please try again.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
